import { useEffect } from 'react'
import { trackPage } from 'lib/tracking/segment'

type Params = Parameters<typeof trackPage>

/**
 * Tracks provided page on initial component render.
 * @param {string} name - descriptive name
 * @returns {void}
 */
export const useTrackPageOnMount = (name: Params[0], props?: Params[1]): void => {
  useEffect(() => {
    trackPage(name, props)
  }, [])
}
